import { TrashIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import Button from "../../../../components/form/Button";
import {
  DestinationLabelMap,
  DestinationTypeEnum,
} from "../../../../enums/destination";
import DestinationDeleteModal from "../modals/DestinationDeleteModal";

interface Props {
  destinationId: string | undefined;
  destinationTypeId: DestinationTypeEnum;
}

const DeleteDestinationButton = ({
  destinationId,
  destinationTypeId,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!destinationId) return null;

  const destinationLabel = DestinationLabelMap[destinationTypeId];

  return (
    <>
      <Button
        variant="light-danger"
        tooltip={`Delete ${destinationLabel} connection`}
        className="group hover:border-red-500 hover:bg-red-50 absolute top-4 right-3"
        onClick={() => setIsModalOpen(true)}
      >
        <TrashIcon className="size-5 text-red-500" />
      </Button>

      {isModalOpen && (
        <DestinationDeleteModal
          destinationId={destinationId}
          onRequestClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default DeleteDestinationButton;
